import OrderPage from '../../../../pages/finance/order';
import HomeFinance from '../../../../pages/finance/[tab]';
import Calculate from '../../../../pages/finance/[tab]/calculate';

export const pagesFinance: Record<string, string> = {
  [OrderPage.name]: '@finance',
  [HomeFinance.name]: '@finance',
  [Calculate.name]: '@finance',
};
